console.log("app.js loaded");

window.onerror = function (message, source, lineno, colno, error) {
    console.error("Global error caught:", { message, source, lineno, colno, error });
};

const cacheBuster = `?v=${new Date().getTime()}`;

// Define loadSummusUtils at the top to ensure it’s accessible
function loadSummusUtils(app) {
    console.log("Defining loadSummusUtils function");
    return app.loadAssets([
        {
            type: 'script',
            attr: {
                src: `//takomo.store/cdn/shop/t/144/assets/summusUtils.js?v=4579530660654217841764233612${cacheBuster}`,
                id: 'summusUtils'
            }
        }
    ]).then(() => {
        console.log("summusUtils.js loaded");
    }).catch(error => {
        console.error("Error loading summusUtils.js:", error);
        throw error;
    });
}

document.addEventListener("DOMContentLoaded", () => {
    console.log("DOMContentLoaded event triggered in app.js");

    // Directly attempt to remove the overlay as an isolated test
    executeSummusLoader().then(() => {
        console.log("Overlay removed successfully in isolated DOMContentLoaded test.");
    }).catch(error => {
        console.error("Error in isolated overlay removal test:", error);
    });

    // Proceed with initializing SummusCore and app functions
    initializeApp();
});

function initializeApp(retries = 3) {
    if (!window.SummusCore) {
        console.error("SummusCore is not available.");
        if (retries > 0) {
            console.log(`Retrying SummusCore initialization (${retries} attempts left)`);
            return setTimeout(() => initializeApp(retries - 1), 500);
        }
        console.error("Failed to initialize SummusCore after multiple attempts");
        return;
    }

    let app;
    try {
        app = new SummusCore();
        console.log("SummusCore instance created");

        app.init(() => {
            console.log("app.init started");

            loadAssetsSequentially(app)
                .then(() => loadSummusUtils(app)) // Ensure loadSummusUtils is called after definition
                .then(() => initializeDialog(app))
                .then(() => setupMenuAndMobileInteractions(app))
                .then(() => setupCartFunctionality(app))
                .then(() => setupTidioChat(app))
                .catch(error => console.error("Error during script execution:", error));
        });
    } catch (error) {
        console.error("Error during app initialization:", error);
        if (retries > 0) {
            console.log(`Retrying SummusCore instance creation (${retries} attempts left)`);
            setTimeout(() => initializeApp(retries - 1), 500);
        } else {
            console.error("Failed to create SummusCore instance after multiple attempts");
        }
    }
}

// Overlay removal function isolated for direct invocation
function executeSummusLoader() {
    return new Promise((resolve, reject) => {
        try {
            console.log("Executing isolated summusLoader function");

            const overlay = document.getElementById('summus-loading_overlay');
            if (overlay) {
                console.log("Found overlay element, proceeding with transitions");
                overlay.classList.add('summus-loading_transition');

                setTimeout(() => {
                    if (overlay && overlay.parentNode) {
                        overlay.parentNode.removeChild(overlay);
                        resolve();
                    } else {
                        reject("Overlay or parent missing at removal time");
                    }
                }, 1100);
            } else {
                reject("Overlay element not found");
            }
        } catch (error) {
            reject(error);
        }
    });
}

// Sequential asset loading function
function loadAssetsSequentially(app) {
    console.log("Starting sequential asset loading");

    const assets = [
        {
            type: 'link',
            attr: {
                href: `//cdn.shopify.com/s/files/1/2275/6691/t/61/assets/summus-theme-v2.css${cacheBuster}`,
                id: 'app-css',
                rel: 'stylesheet',
                type: 'text/css',
                media: 'all'
            }
        },
        {
            type: 'script',
            attr: {
                id: 'clipboardJS',
                src: `//cdn.shopify.com/s/files/1/2275/6691/t/61/assets/clipboard.min.js${cacheBuster}`
            }
        },
        {
            type: 'script',
            attr: {
                id: 'GSAP',
                src: `//cdnjs.cloudflare.com/ajax/libs/gsap/3.6.0/gsap.min.js${cacheBuster}`
            }
        },
        {
            type: 'script',
            attr: {
                id: 'summusToast',
                src: `//takomo.store/cdn/shop/t/144/assets/summus-toast.js?v=182771264899040136261764233612${cacheBuster}`
            }
        }
    ];

    return assets.reduce((promise, asset) => {
        return promise.then(() => app.loadAssets([asset]).catch(error => {
            console.error("Error loading asset:", asset, error);
            throw error;
        }));
    }, Promise.resolve());
}

// Dialog initialization
function initializeDialog(app) {
    console.log("Initializing SummusDialog");

    if (typeof SummusDialog !== 'undefined') {
        window.takomoDialog = window.takomoDialog || new SummusDialog();
        console.log("SummusDialog initialized successfully");
    } else {
        console.error("SummusDialog is not defined after loading summusUtils.js");
        throw new Error("SummusDialog is not defined");
    }
}

// Setup menu and mobile interactions
function setupMenuAndMobileInteractions(app) {
    console.log("Setting up menu and mobile interactions");

    document.querySelectorAll('.summus-main_menu-toggle').forEach(toggle => {
        toggle.addEventListener('click', () => {
            document.body.classList.toggle('main-menu_opened');
        });
    });

    const mobileClose = document.querySelector('.summus-mobile-close');
    document.querySelectorAll('li.has-submenu').forEach(item => {
        item.addEventListener('click', () => {
            document.querySelectorAll('li.has-submenu.selected').forEach(selected => selected.classList.remove('selected'));
            item.classList.add('selected');
            mobileClose.classList.add('is-active');
        });
    });

    mobileClose.addEventListener('click', () => {
        mobileClose.classList.remove('is-active');
        document.querySelectorAll('li.has-submenu.selected').forEach(item => item.classList.remove('selected'));
    });
}

// Setup cart functionality
function setupCartFunctionality(app) {
    console.log("Setting up cart functionality");

    const cartNode = document.querySelector('#takomo-builder_cart');
    const cartClassName = 'cart_opened';

    const cartFunctionality = () => {
        cartNode.classList.toggle(cartClassName);
        document.body.classList.toggle(cartClassName);

        if (cartNode.classList.contains(cartClassName)) {
            new SummusCart().renderCart();
        } else {
            document.querySelector('#summus-cart').classList.remove('cart-new-item');
        }
    };

    document.querySelectorAll('.summus-menu-custom_cart').forEach(cartButton => {
        cartButton.addEventListener('click', cartFunctionality);
    });
}

// Setup Tidio chat
function setupTidioChat(app) {
    console.log("Setting up Tidio chat");

    return app.loadAssets([
        {
            type: 'script',
            attr: {
                src: 'https://code.tidio.co/mno3jqadjklrpsrvellcwgoyq5hmhwhn.js',
                id: 'tidio',
                async: true
            }
        }
    ]).then(() => {
        const tidioCSS = document.createElement('style');
        tidioCSS.innerHTML = `
            div#tidio-chat {
                z-index: 1003;
                position: relative;
            }
        `;
        document.head.appendChild(tidioCSS);
    }).catch(error => {
        console.error("Error setting up Tidio chat:", error);
    });
}
